import { CredentialsStatus } from '../enums/credentials-status.enum';

export class Credentials {

  public accessKeyId: string = null;
  public accessKeySecret: string = null;
  public creationDate: Date = null;
  public id: string;
  public status: CredentialsStatus;

  constructor(backEndCredentials?: BackEndCredentials) {
    if (backEndCredentials) {
      this.accessKeyId = backEndCredentials.access_key_id;
      this.accessKeySecret = backEndCredentials.access_key_secret;
      this.creationDate = backEndCredentials.created_at ? new Date(backEndCredentials.created_at) : null;
      this.id = backEndCredentials.id;
      this.status = backEndCredentials.status;
    }
  }

  public toBackEnd(): BackEndCredentials {
    return {
      access_key_id: this.accessKeyId || null,
      access_key_secret: this.accessKeySecret || null,
      created_at: this.creationDate ? this.creationDate.toString() : null,
      id: this.id,
      status: this.status
    };
  }

  public toBackEndPatch(): BackEndCredentialsPatch {
    return {
      status: this.status
    };
  }

}

export interface BackEndCredentials {
  access_key_id: string;
  access_key_secret: string;
  created_at: string;
  id: string;
  status: CredentialsStatus;
}

export interface BackEndCredentialsPatch {
  status: CredentialsStatus;
}
